module.exports = __webpack_public_path__ + "img/icon_mark_green.b0758fc5.png";